import { SpamDetectionConfigEditorOutput } from './spam-detection-config-editor-output';

export const defaultSpamDetectionConfigEditorOutput: SpamDetectionConfigEditorOutput = {
  enabled: false,
  instructions: '',
  spamDetectedMessage: '',
  spamFilteringPassedMessage: '',
};
